document.addEventListener("DOMContentLoaded", function () {
    let but = document.getElementById("scan-ticket");
    let qrBut = document.getElementById("header_qr");

    if (!but && !qrBut) return;

    const vars = window.wp_vars || {};
    const ajaxUrl =(vars.wp_vars && vars.wp_vars.ajax_url) || "/wp-admin/admin-ajax.php";
    const nonce = vars.nonce || (window.wp_vars && window.wp_vars.nonce) || "";

    async function wpAjax(action, formData) {
        formData.append("action", action);
        if (nonce) {
            formData.append("nonce", nonce);
        }

        const resp = await fetch(ajaxUrl, {
            method: "POST",
            body: formData,
        });
        
        const json = await resp.json();
        if (json.error) throw new Error(json.mgs || "Lỗi máy chủ");
        return json;
    }

    function openScanPopup() {
        // Nếu popup đang mở thì không mở thêm
        if (document.getElementById("scan-ticket-popup")) return;

        const popup = document.createElement("div");
        popup.style.position = "fixed";
        popup.style.top = "0";
        popup.style.left = "0";
        popup.style.width = "100%";
        popup.style.height = "100%";
        popup.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
        popup.style.display = "flex";
        popup.style.flexDirection = "column";
        popup.style.alignItems = "center";
        popup.style.justifyContent = "center";
        popup.style.zIndex = "9999";
        popup.id = "scan-ticket-popup";

        const closeBtn = document.createElement("button");
        closeBtn.innerText = "X Đóng";
        closeBtn.style.position = "absolute";
        closeBtn.style.top = "20px";
        closeBtn.style.right = "20px";
        closeBtn.style.padding = "10px";
        closeBtn.style.cursor = "pointer";

        const mediaContainer = document.createElement("div");
        mediaContainer.style.display = "flex";
        mediaContainer.style.gap = "20px";
        mediaContainer.style.marginBottom = "20px";
        mediaContainer.style.flexWrap = "wrap";
        mediaContainer.style.justifyContent = "center";
        mediaContainer.style.width = "100%";

        const video = document.createElement("video");
        video.style.backgroundColor = "#333";
        video.style.maxWidth = "45%";
        video.style.maxHeight = "60vh";
        video.autoplay = true;
        video.setAttribute("playsinline", true);

        const canvas = document.createElement("canvas");
        canvas.style.display = "none";
        canvas.style.maxWidth = "45%";
        canvas.style.maxHeight = "60vh";
        canvas.style.backgroundColor = "#222";

        mediaContainer.appendChild(video);
        mediaContainer.appendChild(canvas);

        const btnContainer = document.createElement("div");
        btnContainer.style.display = "flex";
        btnContainer.style.gap = "10px";

        const captureBtn = document.createElement("button");
        captureBtn.innerText = "Chụp ảnh";
        captureBtn.style.padding = "10px 20px";
        captureBtn.style.cursor = "pointer";

        const sendBtn = document.createElement("button");
        sendBtn.innerText = "Gửi";
        sendBtn.style.padding = "10px 20px";
        sendBtn.style.cursor = "pointer";
        sendBtn.style.display = "none";

        btnContainer.appendChild(captureBtn);
        btnContainer.appendChild(sendBtn);

        popup.appendChild(closeBtn);
        popup.appendChild(mediaContainer);
        popup.appendChild(btnContainer);
        document.body.appendChild(popup);

        let stream = null;
        let imageBlob = null;

        navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
        .then(function (mediaStream) {
            stream = mediaStream;
            video.srcObject = mediaStream;
        })
        .catch(function (err) {
            alert("Không thể truy cập camera: " + err.message);
            closePopup();
        });

        function closePopup() {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
        popup.remove();
        }

        closeBtn.addEventListener("click", closePopup);

        captureBtn.addEventListener("click", function () {
        if (!stream) return;
        
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        
        canvas.style.display = "block";
        sendBtn.style.display = "block";

        canvas.toBlob(function(blob) {
            imageBlob = blob;
        }, "image/jpeg", 0.9);
        });

        sendBtn.addEventListener("click", async function () {
            if (!imageBlob) return;
            
            const formData = new FormData();
            formData.append("image", imageBlob, "ticket.jpg");

            const originalText = sendBtn.innerText;
            sendBtn.innerText = "Đang gửi...";
            sendBtn.disabled = true;

            try {
                const dataResult = await wpAjax("scan_ticket", formData);
                console.log("Response từ API:", dataResult);
                alert("Gửi ảnh thành công!");
            } catch (error) {
                console.error("Lỗi gửi ảnh:", error);
                alert("Lỗi: " + error.message);
            } finally {
                sendBtn.innerText = originalText;
                sendBtn.disabled = false;
                closePopup();
            }
        });
    }

    if (but) but.addEventListener("click", openScanPopup);
    if (qrBut) qrBut.addEventListener("click", openScanPopup);
});
